module.exports = __webpack_public_path__ + "media/images/flame-16bbbbc37a0bd450e7cc3d6ac1aa0247.svg";